import { useCallback } from 'react';

import { useStarterDashboardPageData } from '#src/app/pages/starterDashboard/pageContext';

import { useDashboardShareActions } from './useDashboardShareActions';
import { useSharePetitionModalContext } from './useSharePetitionModal';

export function useTriggerSharePetitionModal(): () => Promise<void> {
	const {
		data: { petition },
	} = useStarterDashboardPageData();
	const actions = useDashboardShareActions();

	const openSharePetitionModal = useSharePetitionModalContext();
	const triggerShareModal = useCallback(async () => {
		return openSharePetitionModal({ actions, petitionId: petition.id }).waitForResult();
	}, [actions, openSharePetitionModal, petition.id]);

	return triggerShareModal;
}
